/**
 * @Description
 */

import {
  JNPFormNames,
  JNPIdentification
} from '../ts-config';

/**
   * @description 销售指标模块 某字段的完整name
   * @param isFirstYear true第一年 false第二年
   * @param name 字段name
   * @return 数组类型的name
   */
export const fieldNameSaleTarget = (isFirstYear: boolean, name) => {
  return [
    JNPIdentification,
    JNPFormNames.saleTarget,
    isFirstYear ? JNPFormNames.firstYear : JNPFormNames.secondYear,
    name,
  ];
};

/**
   * @description 营业收入模块 某字段的完整name
   * @param isFirstYear true第一年 false第二年
   * @param name 字段name
   * @return 数组类型的name
   */
export const fieldNameOperatingIncome = (isFirstYear, name) => {
  return [
    JNPIdentification,
    JNPFormNames.operatingIncome,
    isFirstYear ? JNPFormNames.firstYear : JNPFormNames.secondYear,
    name,
  ];
};

/**
   * @description 费用成本模块 某字段的完整name
   * @param isFirstYear true第一年 false第二年
   * @param name 字段name
   * @return 数组类型的name
   */
export const fieldNameCostExpense = (isFirstYear, name) => {
  return [
    JNPIdentification,
    JNPFormNames.costExpense,
    isFirstYear ? JNPFormNames.firstYear : JNPFormNames.secondYear,
    name,
  ];
};

/**
   * @description 职工成本模块 某字段的完整name
   * @param isFirstYear true第一年 false第二年
   * @param name 字段name
   * @return 数组类型的name
   */
export const fieldNameEmployeeCost = (isFirstYear, name) => {
  return [
    JNPIdentification,
    JNPFormNames.employeeCompensationCost,
    isFirstYear ? JNPFormNames.firstYear : JNPFormNames.secondYear,
    name,
  ];
};

/**
   * @description 店铺形象成本模块 某字段的完整name
   * @param name 字段name
   * @return 数组类型的name
   */
export const fieldNameStoreImageCost = (name) => {
  return [
    JNPIdentification,
    JNPFormNames.storeImageCost,
    name,
  ];
};

/**
 * @description 店铺工程成本模块 某字段的完整name
 * @param name 字段name
 * @return 数组类型的name
 */
export const fieldNameStoreEngineeringCost = (name) => {
  return [
    JNPIdentification,
    JNPFormNames.storeEngineeringCost,
    name,
  ];
};

/**
 * @description 租赁成本模块 某字段的完整name
 * @param isFirstYear true第一年 false第二年
 * @param name 字段name
 * @return 数组类型的name
 */
export const fieldNameLeaseCost = (isFirstYear, name) => {
  return [
    JNPIdentification,
    JNPFormNames.leaseCost,
    isFirstYear ? JNPFormNames.firstYear : JNPFormNames.secondYear,
    name,
  ];
};

/**
 * @description 其他成本模块 某字段的完整name
 * @param isFirstYear true第一年 false第二年
 * @param name 字段name
 * @return 数组类型的name
 */
export const fieldNameOtherCost = (isFirstYear, name) => {
  return [
    JNPIdentification,
    JNPFormNames.otherCost,
    isFirstYear ? JNPFormNames.firstYear : JNPFormNames.secondYear,
    name,
  ];
};
